import { useSuspenseQuery } from "@apollo/client/react";
import {
  GetCompoundEntityDetailDocument,
  type GetCompoundEntityDetailQuery,
  type GetCompoundEntityDetailQueryVariables,
} from "~/features/compoundEntities/gqls";
import { useTenant } from "~/features/tenant/context";

/** Read a single compound record (detail page fields) for the current tenant. */
export function useCompoundEntityDetail(id: string) {
  const { tenantId } = useTenant();
  if (!tenantId) throw new Error("Tenant ID is required");
  return useSuspenseQuery<GetCompoundEntityDetailQuery, GetCompoundEntityDetailQueryVariables>(
    GetCompoundEntityDetailDocument,
    { variables: { tenantId, id } },
  );
}
